import React from 'react';
import Icon from '../../../components/AppIcon';

const SupportStats = () => {
  const stats = [
  {
    id: 1,
    value: "< 2 min",
    label: "Average Response Time",
    description: "Live chat and phone support",
    icon: "Clock",
    color: "text-primary"
  },
  {
    id: 2,
    value: "100%",
    label: "Customer Satisfaction",
    description: "Based on support interactions",
    icon: "Heart",
    color: "text-red-500"
  },
  {
    id: 3,
    value: "24/7",
    label: "Emergency Support",
    description: "Always available when you need us",
    icon: "Shield",
    color: "text-green-500"
  },
  {
    id: 4,
    value: "1,000+",
    label: "Issues Resolved",
    description: "This year alone",
    icon: "CheckCircle",
    color: "text-blue-500"
  }];


  const supportFeatures = [
  {
    id: 1,
    title: "Multi-Channel Support",
    description: "Reach us through chat, phone, email, or video call",
    icon: "MessageSquare"
  },
  {
    id: 2,
    title: "Expert Team",
    description: "Certified roofing specialists with 10+ years experience",
    icon: "Users"
  },
  {
    id: 3,
    title: "Proactive Monitoring",
    description: "We track your project and reach out before issues arise",
    icon: "Eye"
  },
  {
    id: 4,
    title: "Follow-up Guarantee",
    description: "We ensure your issue is completely resolved",
    icon: "RefreshCw"
  }];


  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-jakarta font-bold text-text-primary mb-4">
            Support by the Numbers
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Our commitment to exceptional customer service is reflected in our performance metrics and customer feedback.
          </p>
        </div>
        
        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats?.map((stat) =>
          <div
            key={stat?.id}
            className="text-center elevation-card p-6 hover:shadow-lg transition-all duration-300">

              <div className="w-16 h-16 mx-auto mb-4 bg-surface rounded-full flex items-center justify-center">
                <Icon name={stat?.icon} size={28} className={stat?.color} />
              </div>
              <div className="text-3xl font-jakarta font-bold text-text-primary mb-2">
                {stat?.value}
              </div>
              <h3 className="font-jakarta font-semibold text-text-primary mb-2">
                {stat?.label}
              </h3>
              <p className="text-sm text-text-secondary">
                {stat?.description}
              </p>
            </div>
          )}
        </div>
        
        {/* Support Features */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {supportFeatures?.map((feature) =>
          <div
            key={feature?.id}
            className="flex items-start space-x-4 p-6 elevation-card hover:shadow-lg transition-all duration-300">

              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={24} className="text-primary" />
              </div>
              <div>
                <h3 className="text-lg font-jakarta font-semibold text-text-primary mb-2">
                  {feature?.title}
                </h3>
                <p className="text-text-secondary">
                  {feature?.description}
                </p>
              </div>
            </div>
          )}
        </div>
        
        {/* Customer Testimonial */}
        <div className="mt-16 bg-gradient-to-r from-primary/5 to-secondary/5 rounded-xl p-8">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-trust">
              <Icon name="Quote" size={24} className="text-primary" />
            </div>
            
            <blockquote className="text-xl text-text-primary mb-6 italic">
              "The support team at OpenbooQ went above and beyond. When we had questions about our warranty claim,
they walked us through every step.
              Exceptional service that made a stressful situation much easier."
            </blockquote>
            
            <div className="flex items-center justify-center space-x-4">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1bb5d2cb2-1763294526193.png"
                alt="Professional headshot of Sarah Chen, satisfied customer with short black hair and warm smile"
                className="w-12 h-12 rounded-full object-cover" />

              <div className="text-left">
                <div className="font-jakarta font-semibold text-text-primary">Sarah Chen</div>
                <div className="text-sm text-text-secondary">Homeowner, Memphis TN</div>
              </div>
            </div>
            
            <div className="flex items-center justify-center space-x-1 mt-4">
              {[...Array(5)]?.map((_, i) =>
              <Icon key={i} name="Star" size={16} className="text-yellow-400 fill-current" />
              )}
              <span className="ml-2 text-sm text-text-secondary">5.0 out of 5 stars</span>
            </div>
          </div>
        </div>
        
        {/* Support Commitment */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 bg-primary/10 rounded-full px-6 py-3 mb-6">
            <Icon name="Award" size={20} className="text-primary" />
            <span className="font-medium text-primary">Our Support Commitment</span>
          </div>
          
          <h3 className="text-2xl font-jakarta font-bold text-text-primary mb-4">
            We Don't Just Fix Problems, We Prevent Them
          </h3>
          <p className="text-text-secondary max-w-2xl mx-auto">
            Our proactive support approach means we monitor your project, anticipate potential issues, 
            and reach out with solutions before problems impact your experience. That's the OpenbooQ difference.
          </p>
        </div>
      </div>
    </section>);

};

export default SupportStats;